import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, Typography, Box } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { StitchIcon } from '../StitchIcons/icons';
import { LoadedStitchGroup, StitchVariantConfig } from '../../stitches/types';

interface VariantDropdownProps {
  group: LoadedStitchGroup;
  language: string;
  color?: string;
  onSelect: (variantId: string) => void;
}

export const VariantDropdown: React.FC<VariantDropdownProps> = ({ group, language, color, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const getName = (v: StitchVariantConfig) =>
    v.names[language] || v.names['en'] || v.id;

  const getAbbr = (v: StitchVariantConfig) =>
    v.abbreviations[language] || v.abbreviations['en'] || '';

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        sx={{ p: 0, width: 16, height: 16, color: '#1976d2' }}
      >
        <ArrowDropDown sx={{ fontSize: 14 }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        {group.config.variants.map(variant => (
          <MenuItem
            key={variant.id}
            onClick={() => {
              onSelect(variant.id);
              setAnchorEl(null);
            }}
            sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}
          >
            <StitchIcon variantId={variant.id} size={20} color={color} />
            <Typography variant="body2">{getName(variant)}</Typography>
            <Typography variant="caption" color="text.secondary">({getAbbr(variant)})</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
